<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectGenders" });
import TagList from "../../../../selects/tag-list/TagList.svelte";
import { GENDERS } from "../../config/genders.js";
export let keys;
export let name = "genders";
export let label = "Genders";
export let isDisabled = false;
export let minItems = 0;
export let maxItems = 1e3;
</script>

{#if Array.isArray(keys) }
    <TagList
        bind:keys
        { name }
        options = { GENDERS }
        { label }
        { minItems }
        { maxItems }
        { isDisabled }
        mode = 'toggle'
    />
{/if}